// Angular
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

// Afidium
import { BookingInTicketingReportComponent } from './booking-in-ticketing-report.component';
import { BookingInTicketingReportRouting } from './booking-in-ticketing-report.routing';
import { CardModule } from 'libraries/ui_card/card.module';
import { EnumsResourceModule } from 'libraries/service/booking/enums/enums-resource.module';
import { ComboboxFieldModule } from 'libraries/module/formbuilder/fields/combobox-field/combobox-field.module';
import { BtnModule } from 'libraries/ui_button/btn.module';
import { BookingInTicketingReportSearchResultModule } from '../booking-in-ticketing-report-search-result/booking-in-ticketing-report-search-result.module';
import { NotificationModule } from 'libraries/component/notification/notification.module';
import { SashaBreadcrumbModule } from 'app_sasha/shared/components/breadcrumb/sasha-breacrumb.module';
import { DateModule } from 'libraries/module/formbuilder/fields/date/date.module';
import { TitleServiceModule } from 'app_sasha/shared/services/title/title-service.module';

@NgModule({
    imports: [
        BookingInTicketingReportRouting,
        CommonModule,
        CardModule,
        ReactiveFormsModule,
        EnumsResourceModule,
        ComboboxFieldModule,
        BtnModule,
        BookingInTicketingReportSearchResultModule,
        NotificationModule,
        SashaBreadcrumbModule,
        DateModule,
        TitleServiceModule,
    ],
    exports: [BookingInTicketingReportComponent],
    declarations: [BookingInTicketingReportComponent],
})
export class BookingInTicketingReportModule { }
